import React, {Component} from 'react'
import { Button, Table } from 'reactstrap';
import {Link} from 'react-router-dom'
import global_standard from './global_standard'
import { Trans } from "react-i18next";

class Accounts extends Component{

    constructor(props) {
	super(props);
    }
    
    
    render(){	
	const {accounts} = this.props


	const value_format = (a, row) => {
	    if(row.value){
		const val = row.value.split('.').reduce((o,i)=> o != null ? o[i] : {}, a)
		if(val !== undefined && val !== null ){
		    if(row.name === 'closing_date')
			return <Trans values={{value: val}}>standard_formatting.date</Trans>
			else
			return <Trans values={{value: val}}>standard_formatting.number</Trans>
		}else
		return '-'
	    }
	}

	
	const BalanceRow = ({rows, level}) =>
	    rows.map(row => <React.Fragment key={row.name}>
		<tr>
		    <td style={{paddingLeft: (8+level*20)+'px'}}><Trans>accounts.{row.name}</Trans></td>
		    {accounts.map(a => <td key={a.closing_date}>{value_format(a, row)}</td>)}
		</tr>

		{Array.isArray(row.childs) ? <BalanceRow key={row.name} rows={row.childs} level={level+1}/> : null}
	    </React.Fragment>)
	

	return <Table striped className="table-accounts">
	    <tbody>
		<BalanceRow rows={global_standard} level={0} />
	    </tbody>
	</Table>
    }
}

Accounts.defaultProps = {
    accounts: []
}
export default Accounts
